import { config } from "../env";
import {
  Delete,
  get,
  patch,
  post,
  postFileUpload,
} from "./helpers/http-handler";

export const adminGetCitiesListManagement = (stateId: number) =>
  get(`${config.API_URL}/location-management/list/cities?state=${stateId}`);

export const adminGetCountriesListManagement = () =>
  get(`${config.API_URL}/location-management/list/countries`);

export const adminGetListManagementGroupCode = (groupCode: string) =>
  get(`${config.API_URL}/list-management/list/${groupCode}`);

export const adminGetStatesListManagement = (countryId: number) =>
  get(`${config.API_URL}/location-management/list/states?country=${countryId}`);
